import { isEmpty } from '@groww-tech-pvt/ella';

import { updateUserDataStore } from './actions';
import { userDataStore } from './store';
import { hasSession } from 'src/utils/helpers';

export const useUserDataStore = () => {
  const {
    userData,
    userAttributes,
    isUserDataLoading,
    isUserDataError,
    userDataError,
    isStoreHydrating,
    isMaskedDataStored,
    lastApiTriggerTimeStamp, // this will help us to know when the last time data was fetched from api available in store
  } = userDataStore();

  const isUser2FaLoggedIn = hasSession(true);

  const shouldUpdateStore =
    isEmpty(userData) &&
    !isUserDataLoading &&
    !isUserDataError &&
    !isStoreHydrating;

  /*
    check if user is logged in with 2fa session and store has masked userData
    this use case can apper when user attribute api is failed after 2fa pin entered
    below check will retry api call to get unmasked user data on page refresh
  */
  const shouldUpdateUnmaskedData =
    isUser2FaLoggedIn &&
    isMaskedDataStored &&
    !isUserDataLoading &&
    !isUserDataError &&
    !isStoreHydrating;

  if (shouldUpdateStore || shouldUpdateUnmaskedData) updateUserDataStore();

  return {
    userData,
    userAttributes,
    isUserDataLoading,
    isUserDataError,
    userDataError,
    isStoreHydrating,
    lastApiTriggerTimeStamp,
  };
};
